export default __webpack_public_path__ + "static/whiteWindow-9751b006e6485767910cb1509503edcd.jpeg";